const grillaBusquedaPGState = {
  modalEditarPrestacion: false,
  openModal: false,
  openModalCaracteristicas: false,
  openModalDetalle: false,
  observacion: '',
  idPrestacionEditar: 0,
  idPaqueteObservacion: 0,
  observacionesGuardadas: [],
  caracteristicasPaquete: [],
  detallePaquete: [],
  totalClinica: 0,
  totalHMQ: 0,
  totalMonto: 0,
};

export default grillaBusquedaPGState;

